import { ComponentType } from 'react';

import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';

interface IRouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: ComponentType;
}

export const Route = ({
  isPrivate = false,
  component: Component,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  computedMatch,
  ...rest
}: IRouteProps & { computedMatch?: unknown }): JSX.Element => {
  const { user: authenticatedUser } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        const shouldRender = !isPrivate === !authenticatedUser;

        return shouldRender ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/dashboard',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};
